'use client';

import React__default, { forwardRef, useState } from 'react';
import { ViewMoreWrapper, ViewMoreContainer, DesktopSheetOptionItem } from '../../ButtonViewMore.css.js';
import '../../../_virtual/_tslib.js';
import 'react-dom';
import useClickAway from '../../../hooks/useClickAway.js';
import '../../../hooks/useMakeSearchable/types.js';
import '../../../Utils/constants.js';
import '../../../services/resumes/types.js';

var DesktopSheet = function (props, refs) {
    var displayAlign = props.displayAlign, options = props.options, isShow = props.isShow, context = props.context, setIsShow = props.setIsShow, _a = props.mode, mode = _a === void 0 ? 'vertical' : _a;
    var _b = useState(isShow), isChildShow = _b[0], setChildShow = _b[1];
    var ref = useClickAway(function () {
        setChildShow(false);
    });
    var onAnimationEnd = function () {
        if (isChildShow)
            return;
        setIsShow(false);
    };
    return (React__default.createElement(ViewMoreWrapper, { displayAlign: displayAlign, ref: refs, style: { position: context.position, left: context.x, top: context.y } },
        React__default.createElement(ViewMoreContainer, { isShow: isChildShow, mode: mode, onAnimationEnd: onAnimationEnd, ref: ref, "data-floating-placement": context.placement, customPadding: props.customPadding }, options.map(function (item, index) {
            return (React__default.createElement(DesktopSheetOptionItem, { mode: mode, key: "item-".concat(index), onClick: function (e) {
                    if (item.isDisabled)
                        return;
                    // prevent being clicked and
                    // trigger click event from parent component
                    e.preventDefault();
                    // Close dropdown on click
                    item.isCloseOnClick && setChildShow(false);
                    // callback onClick function
                    item.onClick && item.onClick();
                }, isDisabled: !!item.isDisabled },
                item.icon ? item.icon : null,
                item.label ? React__default.createElement("div", null,
                    " ",
                    item.label) : null));
        }))));
};
var DesktopSheet$1 = forwardRef(DesktopSheet);

export { DesktopSheet$1 as default };
//# sourceMappingURL=index.js.map
